<template>
  <div :class="$style.container">
    <slot />
  </div>
</template>

<style lang="scss" module>
.container {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 24px;

  :first-child {
    flex-shrink: 0;
  }

  @include mobile-only {
    flex-direction: column;
    gap: 8px;
  }
}
</style>
